<template>

    <section class="highlight-products">
        <div class="row no-gutters">
            <div
                v-for="homepageProduct in products"
                class="col-6 col-md-4 col-lg-2"
            >
                <inertia-link
                    :href="route('products.item', {brand_slug:homepageProduct.brand_slug || '', slug:homepageProduct.slug})"
                >
                    <div>
                        <img
                            :src="homepageProduct.image"
                            :alt="homepageProduct.name"
                        />
                        <div>
                            <h2>{{ homepageProduct.name }}</h2>
                        </div>
                    </div>
                </inertia-link>
            </div>
        </div>
    </section>

</template>

<script>

export default {

    name:'HomepageHighlightProducts',

    props: {
        products: {
            required:true,
            type:Array,
        },
    },

}

</script>
